import { createRouter, createWebHistory } from 'vue-router';

import NProgress from 'nprogress';
import moment from 'moment-timezone';

import { G } from "@/_common";

import { main_routes } from "./routes";
import { user_routes } from "@/_routes";

export const routesObj = {};
main_routes.forEach(e => {
    routesObj[e.name] = e;
});
user_routes.forEach(e => {
    routesObj[e.name] = e;
});

// export const routes = [
//     ...main_routes,
//     ...user_routes,
// ];

export const routes = Array.from([...main_routes.filter(m => !G.disabled_routes.includes(m.name)), ...user_routes]
    .reduce((m, o) => m.set(o.name, o), new Map)
    .values()
);

const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    // history: createWebHashHistory(),
    history: createWebHistory(),
    base: '',
    // base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 }
    }
});

router.beforeEach((to, from, next) => {
    let tokenAuth = false;
    let adminRole = false;

    if (G.dynModal.components.length) {
        G.closeModalAll();
    }

    try {
        if (G.hasClientData('DA_AUTH_TOKEN')) {
            const parts = G.getClientData("DA_AUTH_TOKEN").replace(/-/g, '+').replace(/_/g, '/').split(".");
            const payload = JSON.parse(atob(parts[0] || ''));
            const expires = JSON.parse(atob(parts[1] || ''));

            if (parts.length >= 2) {
                if (moment.utc(expires.exp) < moment.utc()) {
                    G.removeClientData("DA_AUTH_TOKEN");
                    G.removeClientData("DA_AUTHORIZED");
                    tokenAuth = false;
                    G.alert.warning({ toast: true, position: 'center', msg: 'Cari Aktiv sessiyanın vaxtı bitib !' });
                }
                else {
                    tokenAuth = true;
                    G.setClientData("DA_AUTHORIZED", 'true');
                }

                if (payload && (payload.role === 'admin' || payload.role === 'sysadmin')) {
                    adminRole = true;
                }
            } else {
                G.removeClientData('DA_AUTH_TOKEN');
                G.removeClientData("DA_AUTHORIZED");
            }
        }
    } catch (e) {
        G.removeClientData('DA_AUTH_TOKEN');
        G.removeClientData("DA_AUTHORIZED");
        tokenAuth = false;
    }

    const isLoginRoute = to.matched.some(r => r.name === 'login');
    const requiresNone = to.matched.some(r => r.meta?.requireNone === true);
    const requiresAuth = !isLoginRoute
        && to.matched.some(r => r.meta?.requireAuth === true)
        ||
        to.matched.some(r => r.meta?.requireAuth === undefined && !requiresNone);
    const requiresAdmin = to.matched.some(r => r.meta?.requireAdmin === true);
    const firstMatchedName = to.matched[0]?.name;

    if( !isLoginRoute && tokenAuth && firstMatchedName && !G.getUserAccessToMenu(firstMatchedName) ){
        return next({ name: 'notfound' });
    }

    if( !isLoginRoute && requiresAdmin && tokenAuth && !adminRole ){
        return next({ name: 'notperm' });
    }

    if( !isLoginRoute && requiresAuth && !tokenAuth ){
        const safeRedirect =
            (from && from.name !== 'login' && from.fullPath) ||
            (to && to.name !== 'login' && to.fullPath) ||
            '/';

        return next({
            name: 'login',
            query: { redirect: safeRedirect },
            replace: true
        });
    }

    return next();
});

router.beforeResolve((to, from, next) => {
    if (to.name) {
        NProgress.start()
        next();
    } else {
        next();
    }
});

router.afterEach(() => {
    NProgress.done();
});


export default router;
